export default __webpack_public_path__ + "4583a0a58d0baaee8c7ab60c45e41633.svg";